export default __webpack_public_path__ + "static/media/AudiFavicon.a882df42.ico";